import { logger as N } from "../../shared-lib/index.js";
import r from "../managers/braze-instance.js";
import ue from "../models/braze-event.js";
import G from "../models/request-result.js";
const c = {
  ut: (e, o, t) => {
    var n, s;
    const i = new G(),
      l = r.P();
    if (!l)
      return (
        N.info(
          `Not logging event with type "${e}" because the current session ID could not be found.`,
        ),
        i
      );
    const d = l.Vo();
    return (
      i.$e.push(
        new ue(
          t || (null === (n = r.ir()) || void 0 === n ? void 0 : n.getUserId()),
          e,
          new Date().valueOf(),
          d,
          o,
        ),
      ),
      (i.tt =
        (null === (s = r.j()) || void 0 === s ? void 0 : s.Wo(i.$e)) || !1),
      i
    );
  },
};
export default c;
